export default __webpack_public_path__ + "static/media/mui.da72c74b.png";